// Helpers for the GlobalSearchModal "single-select" (compose) mode. The modal keeps two
// selection buckets (existing contacts by id, LinkedIn items by their own key) and the tabs
// write them with a mix of plain arrays and functional updaters. In single-select mode every
// write must collapse to AT MOST ONE item, so the parent wraps the setters and feeds whatever
// the tab produced through `collapseToSingle`.

export interface SelectedLinkedInItem {
	linkedinUrl: string;
	name: string;
	domain?: string;
	companyEnrichId?: number;
	prospectId?: number;
	image?: string;
}

// A stable identity for a LinkedIn selection across the three sources it can come from.
export const linkedInItemKey = (li: SelectedLinkedInItem): string | number =>
	li.prospectId ?? li.companyEnrichId ?? li.linkedinUrl;

// Given the previous selection and the next array a tab tried to set, return the single item
// that should remain selected — the newly-added one (a tab "add" appends to the array), or the
// last item as a fallback. Returns `undefined` when the write removed the selection (a tab
// "toggle off" produces an array without the previously-selected key), which the caller treats
// as "clear the selection".
export function collapseToSingle<T>(
	prev: T[],
	next: T[],
	key: (item: T) => string | number
): T | undefined {
	const prevKeys = new Set(prev.map(key));
	const added = next.find((item) => !prevKeys.has(key(item)));

	return added ?? next[next.length - 1];
}
